/**
 * ============================================
 * CUSTOM OM SCRIPTS
 * All custom JavaScript functionality
 * 1. Product Description Read More Toggle
 * 2. Sticky Cart Widget
 * ============================================
 */


/**
 * Product Description Read More Toggle
 * Truncates description to 20 words and adds read more/less functionality
 * Both button and description text are clickable
 */
document.addEventListener('DOMContentLoaded', function() {
  const descriptionWrapper = document.querySelector('.product__description');
  if (!descriptionWrapper) return;
  
  const descriptionContent = descriptionWrapper.querySelector('[data-full-description]');
  const toggleBtn = descriptionWrapper.querySelector('[data-description-toggle]');
  
  if (!descriptionContent || !toggleBtn) return;
  
  const fullText = descriptionContent.innerText || descriptionContent.textContent;
  const words = fullText.trim().split(/\s+/);
  const wordLimit = 20;
  
  // Only show read more if description has more than 20 words
  if (words.length > wordLimit) {
    const truncatedText = words.slice(0, wordLimit).join(' ') + '...';
    const fullHTML = descriptionContent.innerHTML;
    
    // Store full content
    descriptionContent.dataset.fullContent = fullHTML;
    descriptionContent.dataset.truncatedText = truncatedText;
    
    // Set initial truncated state
    descriptionContent.innerHTML = truncatedText;
    descriptionContent.classList.add('truncated');
    toggleBtn.style.display = 'inline-flex';
    
    let isExpanded = false;
    
    // Function to toggle expand/collapse
    const toggleDescription = function() {
      const readMoreText = toggleBtn.querySelector('.read-more-text');
      const readLessText = toggleBtn.querySelector('.read-less-text');
      
      if (isExpanded) {
        // Collapse - hide heading
        descriptionContent.innerHTML = descriptionContent.dataset.truncatedText;
        descriptionContent.classList.add('truncated');
        readMoreText.style.display = 'inline';
        readLessText.style.display = 'none';
        toggleBtn.classList.remove('expanded');
        isExpanded = false;
      } else {
        // Expand - show full content with heading
        descriptionContent.innerHTML = descriptionContent.dataset.fullContent;
        descriptionContent.classList.remove('truncated');
        readMoreText.style.display = 'none';
        readLessText.style.display = 'inline';
        toggleBtn.classList.add('expanded');
        isExpanded = true;
      }
    };
    
    // Click listener on button
    toggleBtn.addEventListener('click', toggleDescription);
    
    // Click listener on description text
    descriptionContent.addEventListener('click', toggleDescription);
  }
});

/**
 *Sticky Cart Widget
 * Updates cart item count and images dynamically
 */


// let lastCartCount = 0;

// async function updateStickyCartWidget() {
//   try {
//     const response = await fetch('/cart.js');
//     const cart = await response.json();
//     const widget = document.getElementById('sticky-cart-widget');
//     const imagesDiv = document.getElementById('sticky-cart-images');
//     const countSpan = document.getElementById('sticky-cart-count');

//     if (!widget || !imagesDiv || !countSpan) return;

//     if (cart.item_count === 0) {
//       widget.classList.add('hidden');
//       lastCartCount = 0;
//       return;
//     }

//     widget.classList.remove('hidden');
//     imagesDiv.innerHTML = '';
    
//     cart.items.slice(0, 3).forEach(item => {
//       const img = document.createElement('img');
//       img.src = item.image || '';
//       img.alt = item.title || 'Cart item';
//       imagesDiv.appendChild(img);
//     });

//     countSpan.textContent = `${cart.item_count} ${cart.item_count > 1 ? 'items' : 'item'}`;
//     lastCartCount = cart.item_count;
//   } catch (error) {
//     console.error('Error updating sticky cart:', error);
//   }
// }


// const originalFetch = window.fetch;
// window.fetch = function(...args) {
//   const result = originalFetch.apply(this, args);
  
 
//   if (args[0] && (args[0].includes('/cart/add') || args[0].includes('/cart/change') || args[0].includes('/cart/update'))) {
//     result.then(() => {
//       setTimeout(updateStickyCartWidget, 100);
//       setTimeout(updateStickyCartWidget, 300);
//     }).catch(err => console.error('Cart fetch error:', err));
//   }
  
//   return result;
// };


// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', initStickyCart);
// } else {
//   initStickyCart();
// }

// function initStickyCart() {
//   updateStickyCartWidget();
  
 
//   document.addEventListener('click', function(e) {
//     const btn = e.target.closest('button, a, [role="button"]');
//     if (btn) {
//       const text = btn.textContent.toLowerCase();
//       if (text.includes('add to cart') || text.includes('add') || btn.form?.action?.includes('cart/add')) {
//         setTimeout(updateStickyCartWidget, 100);
//         setTimeout(updateStickyCartWidget, 300);
//         setTimeout(updateStickyCartWidget, 600);
//       }
//     }
//   }, true); 

 
//   document.addEventListener('submit', function(e) {
//     if (e.target && (e.target.classList.contains('product-form') || e.target.action?.includes('cart'))) {
//       setTimeout(updateStickyCartWidget, 100);
//       setTimeout(updateStickyCartWidget, 300);
//       setTimeout(updateStickyCartWidget, 600);
//     }
//   });

 
//   document.body.addEventListener('cart:updated', updateStickyCartWidget);
//   document.body.addEventListener('ajaxCart:updated', updateStickyCartWidget);
  
  
//   if (window.PubSub) {
//     PubSub.subscribe('cart:add', updateStickyCartWidget);
//     PubSub.subscribe('cart:update', updateStickyCartWidget);
//     PubSub.subscribe('cart:remove', updateStickyCartWidget);
//   }

 
//   let pollCount = 0;
//   const quickPoll = setInterval(() => {
//     pollCount++;
//     updateStickyCartWidget();
//     if (pollCount >= 10) clearInterval(quickPoll);
//   }, 200);

  
//   const observer = new MutationObserver(() => {
//     updateStickyCartWidget();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['aria-hidden', 'class', 'data-open'],
//   });
// }



document.addEventListener("DOMContentLoaded", () => {

  // STEP 1: By default sabhi p.tag ko hide kar do
  document.querySelectorAll(".card-wrapper .tag").forEach(tag => {
    tag.style.display = "none";
  });

  // STEP 2: Ab check karo collection attribute wale LI
  document.querySelectorAll("li[collection]").forEach(li => {
    const collectionName = li.getAttribute("collection")?.toLowerCase().trim();
    const pTag = li.querySelector(".card-wrapper .tag");

    if (!pTag) return;

    // sirf "best seller" me hi show
    if (collectionName === "best sellers") {
      pTag.textContent = collectionName;
      pTag.style.display = "block";
    }
  });

});
